<div class="advisor-contact-step">
  <div class="advisor-contact-step__header">
    <img src="../../../../assets/svg/orange_contact.svg" class="advisor-contact-step__icon" alt="" aria-hidden="true" />
    <h1 class="title_42">
      <span class="title__stage">{{ "START.ADVISOR.CONTACT_TITLE" | translate }}</span>
    </h1>
    <p class="advisor-contact-step__subtitle">{{ "START.ADVISOR.CONTACT_SUBTITLE" | translate }}</p>
  </div>

  <div class="advisor-contact-step__card">
    <div class="advisor-contact-step__card-content">
      <div class="advisor-contact-step__card-text">
        <p>{{ "START.ADVISOR.CONTACT_LEAVE_EMAIL" | translate }}</p>
        <p class="bold">{{ "START.ADVISOR.CONTACT_ADVISOR_WILL_CONTACT" | translate }}</p>
      </div>
      <div class="advisor-contact-step__card-form">
        <label class="advisor-contact-step__label">{{ "START.ADVISOR.CONTACT_EMAIL_LABEL" | translate }}</label>
        <input
          type="email"
          class="advisor-contact-step__input"
          [(ngModel)]="email"
          [placeholder]="'START.ADVISOR.CONTACT_EMAIL_PLACEHOLDER' | translate"
        />
        <span class="mail-bottom-text" [innerHTML]="'START.ADVISOR.AGREEMENT' | translate"></span>
        <button
          type="button"
          class="btn btn--primary btn--block"
          (click)="onSubmit()"
          [class.is-loading]="isEmailSending"
        >
          {{ "START.ADVISOR.CONTACT_SEND_INQUIRY" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
